import { axiosPrivate as axios } from './axios'

export const fetchOrg = (id) => {
  return axios.get(`/orgs/${id}`)
}
